var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-app"},[_c('a',{attrs:{"href":_vm.downloadPath}},[_vm._v("下载优学APP")])])}
var staticRenderFns = []

export { render, staticRenderFns }